import React from 'react';
import PropTypes from 'prop-types';

export default function UploadTasks({task}) {
  return (
    <div>
      <progress value={task.progress} min={0} max={100} />
      {task.name}
    </div>
  );
};

UploadTasks.propTypes = {
  task: PropTypes.object.isRequired
};
